import { useEffect, useState } from 'react'
import request from './../services/request.js'
import { handlerErrorV2 } from '../utils/errors.jsx'

const useFetchData = (endpoint) => {
  const [data, setData] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      setError(null)
      try {
        const response = await request.get(endpoint)
        if (!response?.data && response?.error) {
          setError(response.error.message || 'An error ocurred')
        } else {
          setData(response?.data || null)
        }
      } catch (error) {
        const message = handlerErrorV2(error)
        setError(message)
      } finally {
        setIsLoading(false)
      }
    }
    fetchData()
  }, [endpoint])

  return { data, isLoading, error }
}

export default useFetchData
